export const getCometDownloadURL = ({ platform, miniInstaller, } = {}) => {
    platform = platform ?? 'mac_arm64';
    // TODO - auto detect and/or configurable params
    const urlParamMap = {
        channel: 'stable',
        platform,
    };
    // Download the mini installer for Windows by default unless explicitly overridden.
    const useMiniInstaller = miniInstaller ?? platform.includes('win');
    if (useMiniInstaller) {
        urlParamMap['mini'] = '1';
    }
    const searchParams = new URLSearchParams(urlParamMap);
    const url = new URL('https://www.perplexity.ai/rest/browser/download');
    url.search = searchParams.toString();
    return url;
};
//# sourceMappingURL=getCometDownloadURL.js.map